import React from 'react';
import T from 'prop-types';

export const ValueLabel = ({ value, className }) => {
    return <div className={className}><span>{value}</span></div>;
};

ValueLabel.T = {
    value: T.string,
    className: T.string,
};

ValueLabel.defaultProps = {
    className: 'valueBoxC',
};
